import { axios } from '../utils/axios';

export type SoundBoardData = {
  _id: string;
  createdBy: 'DEFAULT' | string;
  icon: string;
  name: string;
  volume: number;
  sound?: File;
};

export async function getSounds(): Promise<SoundBoardData[]> {
  const { data } = await axios.get<SoundBoardData[]>(
    `chat/channel/voice/soundboard/sounds`,
  );
  return data;
}

export async function addSound(
  sound: Partial<SoundBoardData>,
): Promise<SoundBoardData> {
  const fd = new FormData();
  Object.entries(sound).forEach(([key, value]) => {
    value = typeof value === 'number' ? value.toString() : value;
    fd.append(key, value);
  });
  const { data } = await axios.post<SoundBoardData>(
    `chat/channel/voice/soundboard/upload-sound`,
    fd,
  );
  return data;
}

export const updateSound = async ({
  soundId,
  name,
  icon,
  volume,
}: { soundId: string; name: string; icon: string; volume: number }) => {
  const { data } = await axios.put<SoundBoardData>(
    `chat/channel/voice/soundboard/sound/${soundId}`,
    {
      name,
      icon,
      volume,
    },
  );
  return data;
};

export const deleteSound = async ({ soundId }: { soundId: string }) => {
  const { data } = await axios.delete<SoundBoardData>(
    `chat/channel/voice/soundboard/sound/${soundId}`,
  );
  return data;
};

export const playSound = async ({
  channelId,
  soundId,
  icon,
}: { channelId: string; soundId: string; icon: string }) => {
  await axios.post('chat/channel/voice/soundboard/play', {
    channelId,
    soundId,
    icon,
  });
};

export * as SoundBoardRequests from './soundboard';
